import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-cost-mgmt',
    templateUrl: './cost-mgmt.component.html',
    styleUrls: ['./cost-mgmt.component.scss'],
    standalone: false
})
export class CostMgmtComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
